/* XC お問い合わせページ: 確認画面ステップ(個人情報はどこにも保存しない) */
(function () {
  'use strict';

  function init(form) {
    if (form.dataset.xcContactInit) return;
    form.dataset.xcContactInit = '1';

    var paneInput = form.querySelector('[data-xc-pane-input]');
    var paneConfirm = form.querySelector('[data-xc-pane-confirm]');
    if (!paneInput || !paneConfirm) return;

    var confirmed = false;
    var lastFocus = null;
    var fields = {
      name: 'input[name="contact[name]"]',
      email: 'input[name="contact[email]"]',
      kind: 'select[name="contact[お問い合わせ種別]"]',
      subject: 'input[name="contact[件名]"]',
      body: 'textarea[name="contact[body]"]'
    };

    /* LPの「入荷通知を受け取る」からの遷移(?xc_type=restock)で種別と件名をプリセット(空欄時のみ・保存はしない) */
    (function presetFromQuery() {
      try {
        var params = new URLSearchParams(window.location.search);
        if (params.get('xc_type') !== 'restock') return;
        var kindSel = form.querySelector(fields.kind);
        if (kindSel && !kindSel.value) {
          for (var i = 0; i < kindSel.options.length; i++) {
            if (kindSel.options[i].text.indexOf('入荷通知') !== -1) { kindSel.selectedIndex = i; break; }
          }
        }
        var subjectInput = form.querySelector(fields.subject);
        if (subjectInput && !subjectInput.value) {
          subjectInput.value = '【入荷通知希望】TORVAULT';
        }
      } catch (e) { /* URLSearchParams非対応環境では何もしない */ }
    })();

    form.addEventListener('submit', function (event) {
      if (confirmed) {
        var send = form.querySelector('[data-xc-send-btn]');
        var back = form.querySelector('[data-xc-back-btn]');
        if (send) send.disabled = true;
        if (back) back.disabled = true;
        return; /* ネイティブ送信を許可 */
      }
      event.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      Object.keys(fields).forEach(function (key) {
        var el = form.querySelector(fields[key]);
        var dd = form.querySelector('[data-xc-review="' + key + '"]');
        if (el && dd) dd.textContent = el.value;
      });
      lastFocus = document.activeElement;
      paneInput.hidden = true;
      paneConfirm.hidden = false;
      var heading = paneConfirm.querySelector('[data-xc-confirm-heading]');
      if (heading) heading.focus();
    });

    var backBtn = form.querySelector('[data-xc-back-btn]');
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        paneConfirm.hidden = true;
        paneInput.hidden = false;
        var target = (lastFocus && paneInput.contains(lastFocus)) ? lastFocus : paneInput.querySelector('input, select, textarea');
        if (target) target.focus();
      });
    }

    var sendBtn = form.querySelector('[data-xc-send-btn]');
    if (sendBtn) {
      sendBtn.addEventListener('click', function () {
        confirmed = true;
      });
    }
  }

  function boot() {
    var forms = document.querySelectorAll('form.xc-contact-form');
    for (var i = 0; i < forms.length; i++) init(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
